import { computed, Ref, ref } from 'vue'
import { defineStore } from 'pinia'

export const FORM = 'form'
export const SPECKLE = 'speckle'

type CalculationDrawerType = typeof FORM | typeof SPECKLE

export const useDrawerStore = defineStore('drawer', () => {
  const drawer = ref({
    shown: false,
    width: 250
  })

  const currentCalculationDrawer: Ref<CalculationDrawerType> = ref(FORM)

  const toggleCalculationDrawer = (drawerType: CalculationDrawerType): void => {
    if (currentCalculationDrawer.value === drawerType) {
      drawer.value.shown = !drawer.value.shown
    } else {
      currentCalculationDrawer.value = drawerType
      drawer.value.shown = true
    }
  }

  const resetCalculationDrawer = (): void => {
    currentCalculationDrawer.value = FORM
    drawer.value.shown = true
  }

  const formDrawerState = computed(() => {
    return currentCalculationDrawer.value === FORM && drawer.value.shown
  })

  const speckleDrawerState = computed(() => {
    return currentCalculationDrawer.value === SPECKLE && drawer.value.shown
  })

  const toggleDrawer = (): void => {
    drawer.value.shown = !drawer.value.shown
  }

  return {
    drawer,
    currentCalculationDrawer,
    formDrawerState,
    speckleDrawerState,
    resetCalculationDrawer,
    toggleDrawer,
    toggleCalculationDrawer
  }
})
